import type { StampRallySummary } from '@/api/types/stamp-rally'

export const isRallyComplete = (rally: Pick<StampRallySummary, 'total_count' | 'stamped_count'>): boolean =>
  rally.total_count > 0 && rally.stamped_count >= rally.total_count
